import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceCallUtilsService {

  constructor(private http: HttpClient) { }

  /**
  * Description: Método que genera los headers de la petición tipo HTTP
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  getHttpHeaderOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
  }

  /**
   * Description: Método que genera los headers de la petición con seguridad de token tipo HTTP
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  getHttpSecureHeaderOptions() {

    let token = (localStorage.getItem("userData") != null)?JSON.parse(localStorage.getItem("userData")).token:"";
    let idNumber = (localStorage.getItem("userData") != null)?JSON.parse(localStorage.getItem("userData")).documentId:"";
    let idType = (localStorage.getItem("userData") != null)?JSON.parse(localStorage.getItem("userData")).documentType:"";
    let mobileLine = (localStorage.getItem("userData") != null)?JSON.parse(localStorage.getItem("userData")).phone:"";

    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': token,
        'idNumber': idNumber,
        'idType': idType,
        'mobileLine': mobileLine
      })
    }
  }

  /**
  * Description: Método que maneja la excepción del llamado al webservice
  * Autor: Diego Diaz
  * @param error, indica el tipo de error ocurrido durante el llamado
  * @return N/A
  * @throws Web Service Exception
  */
  handleError(error) {
    let errorMessage = null;
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = { "code": error.status, "msg": error.message };
    }
    return throwError(errorMessage);
  }

  callSecuredGetWebService(endpoint) {
    return this.http.get(
      environment.apiUrl + endpoint,
      this.getHttpSecureHeaderOptions())
      .pipe(
        retry(environment.retryTimes),
        catchError(this.handleError)
      );
  }
  
  /**
   * Description: Método que llama un webservice via POST
   * Autor: Diego Diaz
   * @param endpoint indica la URL o nombre del servicio que se va a consumir
   * @param data contiene los parámetros de entrada al servicio
   * @return N/A
   * @throws Web Service Exception
   */
  callPostWebService(endpoint, data) {
    return this.http.post(
      environment.apiUrl + endpoint,
      data,
      this.getHttpHeaderOptions())
      .pipe(
        retry(environment.retryTimes),
        catchError(this.handleError)
      );
  }

  /**
   * Description: Método que llama un webservice via POST con seguridad
   * Autor: Diego Diaz
   * @param endpoint indica la URL o nombre del servicio que se va a consumir
   * @param data contiene los parámetros de entrada al servicio
   * @return N/A
   * @throws Web Service Exception
   */
  callSecuredPostWebService(endpoint, data) {
    return this.http.post(
      environment.apiUrl + endpoint,
      data,
      this.getHttpSecureHeaderOptions())
      .pipe(
        retry(environment.retryTimes),
        catchError(this.handleError)
      );
  }

    /**
   * Description: Método que llama un webservice via POST tipo texto
   * Autor: Diego Diaz
   * @param endpoint indica la URL o nombre del servicio que se va a consumir
   * @param data contiene los parámetros de entrada al servicio
   * @return N/A
   * @throws Web Service Exception
   */
  callPostTextWebService(endpoint, data) {
      return this.http.post(
        environment.apiUrl + endpoint,
        data,
        {responseType: 'text'})
  }
}
